class CartDrawer extends HTMLElement {
	constructor() {
		super()
		window.FoxTheme = window.FoxTheme || {}
		window.FoxTheme.Cart = this
		this.drawer = this.closest('drawer-component')
		window.FoxTheme.CartDrawer = this.drawer
    this.openWhenAdded = this.dataset.openWhenAdded === 'true'
    this.liveRegionTimeout = null
	}

	// connectedCallback() {
  //   window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, async state => {
  //     this.renderContents(state)
  //     this.announceItemAdded(state)
  //   })
	// }

connectedCallback() {
    window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, async state => {
      this.renderContents(state)
      setTimeout(() => this.announceItemAdded(state), 800)
    })

    // Reveal cart content to screen readers when the user actually
    // engages with the drawer (clicks, tabs, or presses keys inside it).
    const reveal = () => this.revealContent()
    this.addEventListener('focusin', reveal)
    this.addEventListener('click', reveal)
    this.addEventListener('keydown', reveal)

    // Hide it again when the drawer closes
    if (this.drawer) {
      this.drawer.addEventListener('close', () => this.hideContent())
    }
  }

  async announceItemAdded(state) {
    const liveRegion = document.getElementById('CartDrawer-LiveRegionText')
    if (!liveRegion) return

    const productTitle = state && state.product_title ? state.product_title : ''

    let itemCount = null
    let formattedTotal = ''
    try {
      const cart = await FoxThemeCartHelpers.getState()
      if (cart) {
        itemCount = cart.item_count
        if (typeof formatMoney === 'function') {
          formattedTotal = formatMoney(cart.total_price, window.FoxThemeSettings.money_format)
        }
      }
    } catch (e) {
    }

    let message
    if (itemCount !== null && formattedTotal) {
      const itemWord = itemCount === 1 ? 'item' : 'items'
      message = `${productTitle} added to cart. Cart now has ${itemCount} ${itemWord}, subtotal ${formattedTotal}.`
    } else if (itemCount !== null) {
      const itemWord = itemCount === 1 ? 'item' : 'items'
      message = `${productTitle} added to cart. Cart now has ${itemCount} ${itemWord}.`
    } else {
      message = `${productTitle} added to cart.`
    }

    liveRegion.textContent = ''
    requestAnimationFrame(() => {
      liveRegion.textContent = message
    })

    if (this.liveRegionTimeout) clearTimeout(this.liveRegionTimeout)
    this.liveRegionTimeout = setTimeout(() => {
      liveRegion.textContent = ''
    }, 1000)
  }

  renderContents(parsedState, renderFooter = true) {
    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // setTimeout(() => {
    //   if (this.openWhenAdded && !this.drawer.isOpen()) {
    //     this.drawer.openDrawer()
    //     document.body.classList.add('prevent-scroll')
    //     window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState)
    //   }
    // });

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer()
        document.body.classList.add('prevent-scroll')
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState)

        setTimeout(() => {
          const closeBtn = this.drawer.querySelector('drawer-closer')
          if (closeBtn) closeBtn.focus()
        }, 100)
      }
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
    ]

    if (renderFooter) {
      sections.push({
        id: 'cart-drawer',
        selector: '.f-drawer__footer',
      })
    }

    return sections
  }

  revealContent() {
    if (!this.drawer) return
    const hiddenZones = this.drawer.querySelectorAll('[data-cart-content]')
    hiddenZones.forEach(zone => zone.setAttribute('aria-hidden', 'false'))
  }

  hideContent() {
    if (!this.drawer) return
    const hiddenZones = this.drawer.querySelectorAll('[data-cart-content]')
    hiddenZones.forEach(zone => zone.setAttribute('aria-hidden', 'true'))
  }

}
customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {

  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.querySelector('cart-drawer'), { overlay: document.querySelector('cart-drawer') })
  }
  getSectionsToRender() {
    return [
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__block-subtotal',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);